<template>
  <div class="page-wrapper">
    <Menu>
      <ul class="sidebar-panel-nav">
        <li v-for="(navItem, index) in data[language].collections" :key="index">
          <a :href="navItem.link" target="_blank">{{ navItem.company }}</a>
        </li>
      </ul>
    </Menu>

    <Hero 
      :title="data[language].bannerTitle" 
      :bannerButton="data[language].bannerButton" 
      :showreel="data[language].showreel"
      :bannerVideo="data[language].bannerVideo"/>

    <Collections
      :instruction="data[language].instruction"
      :data="data[language].collections"
      :collectionButton="data[language].collectionButton"
      :language="language"
    />

    <section class="p-6">
      <div class="container has-text-centered">
        <a
          v-if="data[language].contact !== undefined"
          :href="data[language].contact.email"
          class="button is-primary"
        >
          {{ data[language].contact.text }} <i class="fas fa-envelope"></i>
        </a>
      </div>
    </section>
  </div>
</template>

<script>
import Menu from "../components/Menu.vue";
import Hero from "../components/Hero.vue";
import Collections from "../components/Collections.vue";

export default {
  components: { Menu, Hero, Collections },
  props: {
    data: {
      type: Object,
      default: null,
    },
    language: {
      type: String,
      default: 'english'
    }
  },
};
</script>

<style scoped>
</style>